exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "table{padding:0;border:1px solid #cbcbcb;border-spacing:0}table tr{border-top:1px solid #ccc;background-color:#fff;margin:0;padding:0}table tr:nth-child(2n){background-color:#f8f8f8}thead tr th{font-weight:700;background-color:#fff}tbody tr td,thead tr th{border:1px solid #ccc;text-align:left;margin:0;padding:6px 13px}table tr td :first-child,thead tr th :first-child{margin-top:0}table tr td :last-child,table tr th :last-child{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/styles/tables.css
// module id = ./src/styles/tables.css
// module chunks = 0